<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
    <v-layout v-if="fault!=undefined" column fill-height :key="fault">
      <v-flex d-flex md3 style="max-height:25%;">
        <v-layout row>
          <v-flex d-flex md6>
            <v-layout column fill-height>
              <v-flex d-flex style="max-height:40px;">
                <v-layout row>
                  <v-flex d-flex md8 class="fdTitle" style="align-items:center;">Possible Causes</v-flex>
                  <v-flex d-flex md4 class="fdTitle" style="align-items:center;">Maintenance Task</v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-if="typeof fault.events != 'undefined'" d-flex style="overflow:auto;flex-direction:column;">
                <v-layout
                    row
                    v-if="typeof fault.events != 'undefined' && fault.events[0].causes"
                    v-for="(cause, index) in fault.events[0].causes"
                    :key="cause"
                    style="max-height:50px;">
                  <v-flex d-flex md8 style="border-style: solid;border-color:rgb(219,219,219);border-width:1px;">{{ index + 1 }}. {{ cause }}</v-flex>
                  <v-flex d-flex md4 style="border-style: solid;border-color:rgb(219,219,219);border-width:1px;justify-content:center;align-items:center;">
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md6 style="padding-left:10px;">
            <v-layout column fill-height>
              <v-flex d-flex style="max-height:40px;align-items:center;" class="fdTitle">Comments</v-flex>
              <v-flex d-flex>
                <v-textarea outline auto-grow :value="faultComment" disabled/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex md9 style="max-height:75%;">
        <v-layout row>
          <v-flex d-flex md4>
            <v-layout column fill-height>
              <v-flex d-flex md6>
                <Card v-if="Panel1=='Card'" v-bind:cardData="Panel1Data" v-bind:flat="true"/>
                <BarChart v-if="Panel1=='Bar'" v-bind:chartOptions="Panel1Data" v-bind:title="Panel1Title" v-bind:active="active" v-bind:flat="true"/>
              </v-flex>
              <v-flex d-flex md6>
                <Card v-if="Panel2=='Card'" v-bind:cardData="Panel2Data" v-bind:flat="true"/>
                <BarChart v-if="Panel2=='Bar'" v-bind:chartOptions="Panel2Data" v-bind:title="Panel2Title" v-bind:active="active" v-bind:flat="true"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md8>
            <Schematic v-bind:schematicSource="schematicSource" v-bind:points="points" v-bind:initWidth="initWidth" v-bind:initHeight="initHeight" v-bind:active="active"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div v-else style="width:100%;height:100%;background-color:white;display:flex;justify-content:center;align-items:center;">
      <v-img :src="require('../assets/check-mark-circle3.png')" contain height="200"></v-img>
    </div>
  </v-container>

</template>

<script>

import BarChart from '../controls/BarChart'
import Schematic from '../controls/Schematic'
import Card from '../controls/Card'

import {globalStore} from "../main.js"

export default {
  name: 'EngineFaultsData',
  components: {
    Schematic,
    BarChart,
    Card
  },
  props: {
    fault: Object,
    active: Boolean
  },
  data() {
    return {
      maintImg: require('../assets/icon-maintenance_light.png'),
      Panel1Title: "Title 1",
      Panel2Title: "Title 2",
      Panel1: '',
      Panel2: '',
      Panel1Data: {},
      Panel2Data: {},
      schematicSource: require('../assets/fuel-injection-schematic-light.png'),
      points: {},
      initWidth: 1820,
      initHeight: 1134,
      faultData: {},
      idName: "FuelInjection",
      faultComment: ''
    }
  },
  computed: {},
  methods: {
    setData() {
      if (!!!this.fault) {
        return;
      }

      let subsystem = this.fault.subsystem;

      this.initWidth = 1820;

      if (subsystem == 'Servo Oil') {
        this.schematicSource = require('../assets/servo-oil-schematic-light.png');

        this.points = {
          "Servo Oil Rail": {x: 56, y: 540, color: 0},
          "VCU": {x: 1001, y: 252, color: 0},
          "Exhaust Valve": {x: 1624, y: 295, color: 0}
        };
      } else if (subsystem == 'Fuel Injection') {
        this.schematicSource = require('../assets/fuel-injection-schematic-light.png');

        this.points = {
          "Injectors": {x: 1285, y: 741, color: 0}
        };
      } else if (subsystem == 'Piston Running') {
        this.schematicSource = require('../assets/piston-schematic-light.png');

        this.points = {
          "Cylinder Liner": {x: 693, y: 298, color: 0}
        };
      } else if (subsystem == 'Gas Admission') {
        this.schematicSource = require('../assets/gas-admission-schematic-light.png');

        this.points = {
          "Gas Admission Valve Exhaust Side": {x: 596, y: 723, color: 0},
          "Pilot Fuel Injectors": {x: 702, y: 382, color: 0},
          "Pilot Fuel Rail": {x: 642, y: 210, color: 0},
          "Gas Admission Valve Fuel Side": {x: 1127, y: 723, color: 0}
        };
      } else {

        this.initWidth = 910;

        this.schematicSource = require('../assets/scavenge-exhaust-schematic-light.png');

        this.points = {
          "Turbine": {x: 444, y: 640, color: 0},
          "Scavenge Air Cooler": {x: 609, y: 860, color: 0},
          "Air Flaps": {x: 414, y: 815, color: 0},
          "Compressor": {x: 614, y: 640, color: 0}
        };
      }

      if (typeof this.fault.component != 'undefined') {
        if (this.fault.component in this.points) {
          this.points[this.fault.component].color = this.fault.color;
        } else {
          let key = Object.keys(this.points).find(item => item.toLowerCase() == this.fault.component.toLowerCase());
          this.points[key].color = this.fault.color;
        }
      }

      if (typeof this.fault.events != 'undefined') {
        let length = this.fault.events.length;

        this.faultData = this.fault.events[length - 1];
      } else {
        this.faultData = [];
      }

      if ('comment' in this.fault) this.faultComment = this.fault.comment;
      else this.faultComment = '';

      if ((this.faultData.code == "PR_1_v2")|| (this.faultData.code == "PR_3")) 
        this.setRPanel();
      else this.setPanel(); 

      globalStore.loading = false;
    },
    setPanel: function () {

      var mapping = globalStore.mapping[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      for (let i = 0; i < 2; i++)
      {        
          this["Panel"+ (i+1)+"Title"] = "";
          this["Panel" + (i+1)]= '';

          var panel = this.faultData["panel" + (i+1)];
          
          if (panel["type"] != null)
          {
              if (panel["type"] == "chart") this.addBarChart(panel, i+1);
              // else if (panel["type"]== "check") this.addCheck(panel, i+1);
              else this.addCard(panel, i+1);
          } 

      }
    },
    addCard: function (panelData, panelNum) {
      var mapping = globalStore.mapping[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      let compType = panelData["compType"];

      let param = panelData["param"],
          lower = panelData["lowerLim"],
          upper = panelData["upperLim"];

      let index = -1;
      if (param.includes("%d"))
      {        
        index = this.fault.index- 1;
      }

      param = param.replace("%d", "");
      this["Panel"+ panelNum +"Title"]  = mapping['mapping'][param];
      if (index>0) this["Panel"+ panelNum +"Title"]  += ' ' + this.fault.element + ' ' + this.fault.index;
      
      let paramData = this.fault.data[this.faultData["Date"]][param]

      let val, exp;

      if (index < 0)
      {
          val = this.average(paramData["meas"]);
          exp = this.average(paramData["ref"]);
      }
      else
      {
          val = paramData["meas"];
          exp = paramData["ref"];
      }

      let state = -10;

      if (val != -1000)
      {
          let temp;

          if (compType == "Value") temp = val;
          else if (compType == "Diff") temp = val - exp;
          else temp = ((val - exp) / val) * 100;

          if ((temp > lower) && (temp < upper)) state = 0;
          else state = 20;
          
      }
      
      this['Panel'+panelNum+'Data'] = {
        value: val,
        ref: exp,
        title: mapping['mapping'][param],
        unit: "",
        format: 1,
        color: state
      };

      if  (index>0) this["Panel"+ panelNum+'Data']['title']  += ' ' + this.fault.element + ' ' + this.fault.index;

      this['Panel'+panelNum] =  'Card';
    },
    addBarChart: function (panelData, panelNum) {
      var mapping = globalStore.mapping[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      this['Panel'+panelNum+'Data'] = {
        credits: {enabled: false},
        time: {
          useUTC: true
        },
        chart: {
          height: 300,
          zoomType: 'xy'
        },
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b> : ' + this.point.y.toFixed(2);
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Time',
            align: 'high'
          },
          labels: {
            format: '{value:%H:%M}'
          },
          crosshair: true
        },
        yAxis: {
          title: {
            text: '',
            align: 'high'
          }
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        series: [{
          type: 'column',
          animation: false,
          data: [],
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }]
      };

      let compType = panelData["compType"];

      if (compType == "Value")
        this['Panel'+panelNum+'Data'].yAxis.title.text = "Values";
      else if (compType == "Diff")
        this['Panel'+panelNum+'Data'].yAxis.title.text = "Diff.";
      else
        this['Panel'+panelNum+'Data'].yAxis.title.text = "% Diff.";

      let param = panelData["param"],
          lower = panelData["lowerLim"],
          upper = panelData["upperLim"],
          faultDate = new Date(this.faultData["Date"] + '.000Z'),
          minus30Date = new Date(faultDate.getTime() - 30 * 60000);

      let index = -1;
      if (param.includes("%d"))
      {        
        index = this.fault.index- 1;
      }

      param = param.replace("%d", "");
      this["Panel"+ panelNum +"Title"]  = mapping['mapping'][param];
      if (index>0) this["Panel"+ panelNum +"Title"]  += ' ' + this.fault.element + ' ' + this.fault.index;
         
      let keys = Object.keys(this.fault["data"]).sort();
      
      keys.forEach(item => {
        let dt = new Date(item + '.000Z');

        if ((dt <= faultDate) && (dt >= minus30Date)) {

          let paramData = this.fault.data[item][param];

          if (paramData==undefined)
            return;
          
          let val, exp;

          if (index < 0)
          {
              val = this.average(paramData["meas"]);
              exp = this.average(paramData["ref"]);
          }
          else
          {
              val = paramData["meas"][index];
              exp = paramData["ref"][index];
          }          

          if (val != -1000) {
            let barValue = 0, color = 'rgb(60, 171, 48)';

            if (compType=="Value") barValue = val;
            else if (compType == "Diff") barValue = val - exp;
            else barValue = ((val - exp) / val) * 100;

            if ((barValue >= lower) && (barValue <= upper))
              color = 'rgb(60, 171, 48)'
            else color = 'rgb(205, 57, 64)';
            
            this['Panel'+panelNum+'Data'].series[0].data.push({
              x: dt,
              y: barValue,
              color: color
            });
          }
        }
      });

      this['Panel'+panelNum] = 'Bar';
    },
    setRPanel: function () {       
      
      this["Panel1Title"] = "";
      this["Panel1"]= '';
      this['Panel1Data'] = {}; 

      this.Panel1Title = "Liner Wall Temperature";

      this.addRAreaChart(1);
      
      this["Panel2Title"] = "";
      this["Panel2"]= '';
      this['Panel2Data'] = {}; 

      this.Panel2Title = 'Fault progress';

      this.addRBarChart('Panel2', 'Panel2Data');
    },
    addRAreaChart: function (panelNum) {
      var units = globalStore.units[globalStore.selectedIMO];

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      var mapping = globalStore.mapping[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      this['Panel'+panelNum+'Data'] = {
        credits: {enabled: false},
        time: {
          useUTC: true
        },
        chart: {
          height: 300,
          zoomType: 'xy'
        },
        legend: {
          enabled: true
        },
        exporting: {
          enabled: false
        },
        tooltip: {
          shared: true,
          formatter: function () {
            return this.points.reduce(function (s, point) {
              return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
            }, '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b>');
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Time',
            align: 'high'
          },
          labels: {
            format: '{value:%H:%M}'
          },
          crosshair: true
        },
        yAxis: {
          title: {
            text: '[' + units['tlineraft'] + ']',
            align: 'high'
          }
        },
        title: {
          text: undefined
        },
        series: []
      };


      let faultDate = new Date(this.faultData["Date"] + '.000Z');

      let minus30Date = new Date(faultDate.getTime() - 30 * 60000);
      let index = 0;
      this.faultData.lwtSensors.forEach((param,index) => {

        this['Panel'+panelNum+'Data'].series.push({
          type: 'line',
          name: mapping.mapping[param] +" "+this.faultData.index ,
          animation: false,
          marker: {
            enabled: false
          },
          data: [],
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        });

        var keys = Object.keys(this.fault.data).sort((a, b) => (new Date(a).getTime() > new Date(b).getTime()) ? 1 : -1);

        for (let i = 0; i < keys.length; i++) {
          let dt = new Date(keys[i] + '.000Z');

          if ((dt <= faultDate) && (dt >= minus30Date)) {
            this['Panel'+panelNum+'Data'].series[index].data.push({
              x: dt,
              y: this.fault.data[keys[i]][param+this.faultData.index]
            });
          }
        }
        
      });
      
      this['Panel'+panelNum] = 'Bar';
    },
    addRBarChart: function (cardBool, chartData) {
      this[chartData] = {
        credits: {enabled: false},
        time: {
          useUTC: true
        },
        chart: {
          height: 300,
          zoomType: 'xy'
        },
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            let fault = 'Nominal';//healthy

            if (this.point.y > 10) fault = 'Alert';
            else if (this.point.y > 5) fault = 'Warning';

            return '<b>' + new Date(this.x).toISOString().substring(0, 16).replace('T', ' ') + '</b> : ' + fault;//+ this.point.y.toFixed(2);
          }
        },
        exporting: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Time',
            align: 'high'
          },
          labels: {
            format: '{value:%H:%M}'
          },
          crosshair: true
        },
        yAxis: {
          visible: false
        },
        title: {
          text: undefined
        },
        series: [{
          type: 'column',
          animation: false,
          data: [],
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }]
      };

      let faultDate = new Date(this.faultData["Date"] + '.000Z');

      let dt = new Date(faultDate.getTime() - 30 * 60000);

      if (typeof this.fault.events != 'undefined') {
        while (dt <= faultDate) {
          var temp = this.fault.events.filter(function (item) {
            return new Date(item.Date + '.000Z').getTime() == dt.getTime();
          });

          let val, color;

          if (temp.length == 0) {
            val = 5;
            color = 'rgb(60, 171, 48)';
          } else {
            val = temp[0].color;

            if (val == 10)
              color = 'rgb(255, 184, 29)';
            else
              color = 'rgb(205, 57, 64)';
          }

          this[chartData].series[0].data.push({
            x: dt,
            y: val,
            color: color
          });

          dt = new Date(dt.getTime() + 60000);
        }
      }

      this[cardBool] = 'Bar';
    }, 
    average: function (list) {      

      let sum = 0, count = 0;
      list.forEach(item=>
      {
          if (item != -1000)
          {
              sum += item;
              count++;
          }
      })

      if (count == 0) return -1000;
      else return sum / count;
    },
  },
  watch: {
    fault: {
      handler: function () {
        this.setData();
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.fdTitle {
  font-size: 18px;
  color: rgb(115, 115, 115);
}

</style>
